import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { onMounted, onUnmounted, ref } from '../../../adapter-vue';
import { TUIStore, StoreName, TUIChatService, TUITranslateService } from '@tencentcloud/chat-uikit-engine';
import Overlay from '../../common/Overlay/index.vue';
import Transfer from '../../common/Transfer/index.vue';
import { Toast, TOAST_TYPE } from '../../../components/common/Toast';
import { isUniFrameWork } from '../../../utils/env';
import { isEnabledMessageReadReceiptGlobal } from '../utils/utils';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    var isShowForwardPanel = ref(false);
    var customConversationList = ref();
    onMounted(() => {
      TUIStore.watch(StoreName.CONV, {
        conversationList: onConversationListUpdated
      });
      TUIStore.watch(StoreName.CUSTOM, {
        singleForwardMessageID: onSingleForwardMessageIDUpdated
      });
    });
    onUnmounted(() => {
      // 组件卸载时需要清掉数据 否则小程序会自动打开
      TUIStore.update(StoreName.CUSTOM, 'singleForwardMessageID', undefined);
      TUIStore.unwatch(StoreName.CONV, {
        conversationList: onConversationListUpdated
      });
      TUIStore.unwatch(StoreName.CUSTOM, {
        singleForwardMessageID: onSingleForwardMessageIDUpdated
      });
    });
    function onSingleForwardMessageIDUpdated(messageID) {
      if (typeof messageID !== 'undefined') {
        openForwardPanel();
      }
    }
    function closeForwardPanel() {
      // ! 必须通过close函数关闭转发面板 singleForwardMessage必须清掉
      TUIStore.update(StoreName.CUSTOM, 'singleForwardMessageID', undefined);
      isShowForwardPanel.value = false;
    }
    function openForwardPanel() {
      isShowForwardPanel.value = true;
    }
    function finishSelected(selectedConvIDWrapperList) {
      /**
       * 这里传递的是 coversationID
       * 但为了实现 Transfer 的复用 这里用 userID 代替 ConversationID
       */
      var selectedConversationList = selectedConvIDWrapperList.map(convIDWrapper => {
        var {
          userID: conversationID
        } = convIDWrapper;
        return TUIStore.getConversationModel(conversationID);
      });
      var singleForwardMessageID = TUIStore.getData(StoreName.CUSTOM, 'singleForwardMessageID');
      var message = TUIStore.getMessageModel(singleForwardMessageID);
      TUIChatService.sendForwardMessage(selectedConversationList, [message], {
        params: {
          needReadReceipt: isEnabledMessageReadReceiptGlobal()
        }
      }).catch(error => {
        if (error.code === 80001) {
          Toast({
            message: TUITranslateService.t('内容包含敏感词汇'),
            type: TOAST_TYPE.ERROR
          });
        } else {
          Toast({
            message: error.message,
            type: TOAST_TYPE.ERROR
          });
        }
      });
      closeForwardPanel();
    }
    function onSubmit(convIDWrapperList) {
      if ((convIDWrapperList === null || convIDWrapperList === void 0 ? void 0 : convIDWrapperList.length) === 0) return;
      finishSelected(convIDWrapperList);
    }
    function onConversationListUpdated(list) {
      customConversationList.value = list.map(conversation => {
        return {
          // 为了实现Transfer的复用，这里用userID代替ConversationID
          userID: conversation.conversationID,
          nick: conversation.getShowName(),
          avatar: conversation.getAvatar()
        };
      });
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(Overlay, {
        visible: _unref(isShowForwardPanel),
        useMask: false
      }, {
        default: _withCtx(() => [_createVNode(Transfer, {
          title: _unref(TUITranslateService).t('TUIChat.转发'),
          isSearch: false,
          isCustomItem: false,
          list: _unref(customConversationList),
          isHiddenBackIcon: _unref(isUniFrameWork),
          onCancel: closeForwardPanel,
          onSubmit: onSubmit
        }, null, 8, ["title", "list", "isHiddenBackIcon"])]),
        _: 1
      }, 8, ["visible"]);
    };
  }
});